<template>
  <div class="parameter-configuration">
    <a-card :bordered="false">
      <!-- Page title -->
      <div class="page-title">{{ $t('system.parameterConfiguration.title') }}</div>

      <!-- Loan APP - View/Edit mode -->
      <div class="app-section">
        <div class="section-header">
          <span class="app-name">| {{ $t('system.parameterConfiguration.loanApp') }}</span>
          <div v-if="!loanEditMode">
            <a-button type="primary" @click="handleEdit('loan')">{{ $t('system.parameterConfiguration.edit') }}</a-button>
          </div>
          <div v-else>
            <a-button @click="handleLoanCancel" style="margin-right: 8px">{{ $t('system.parameterConfiguration.cancel') }}</a-button>
            <a-button type="primary" @click="handleLoanSave">{{ $t('system.parameterConfiguration.save') }}</a-button>
          </div>
        </div>
        <div class="section-content">
          <div class="info-item">
            <span class="label">{{ $t('system.parameterConfiguration.contactPhone') }}</span>
            <span v-if="!loanEditMode" class="value">{{ loanAppData.contactPhone }}</span>
            <a-input v-else v-model="loanAppEditData.contactPhone" :placeholder="$t('system.parameterConfiguration.inputPlaceholder')" style="width: 200px;" />
          </div>
          <div class="info-item">
            <span class="label">{{ $t('system.parameterConfiguration.whatsappAccount') }}</span>
            <span v-if="!loanEditMode" class="value">{{ loanAppData.whatsappAccount }}</span>
            <a-input v-else v-model="loanAppEditData.whatsappAccount" :placeholder="$t('system.parameterConfiguration.inputPlaceholder')" style="width: 200px;" />
          </div>
          <div class="info-item">
            <span class="label">{{ $t('system.parameterConfiguration.email') }}</span>
            <span v-if="!loanEditMode" class="value">{{ loanAppData.email }}</span>
            <a-input v-else v-model="loanAppEditData.email" :placeholder="$t('system.parameterConfiguration.inputPlaceholder')" style="width: 200px;" />
          </div>
        </div>
      </div>

      <!-- Invest APP - View/Edit mode -->
      <div class="app-section">
        <div class="section-header">
          <span class="app-name">| {{ $t('system.parameterConfiguration.investApp') }}</span>
          <div v-if="!investEditMode">
            <a-button type="primary" @click="handleInvestEdit">{{ $t('system.parameterConfiguration.edit') }}</a-button>
          </div>
          <div v-else>
            <a-button @click="handleInvestCancel" style="margin-right: 8px">{{ $t('system.parameterConfiguration.cancel') }}</a-button>
            <a-button type="primary" @click="handleInvestSave">{{ $t('system.parameterConfiguration.save') }}</a-button>
          </div>
        </div>
        <div class="section-content">
          <div class="info-item">
            <span class="label">{{ $t('system.parameterConfiguration.contactPhone') }}</span>
            <span v-if="!investEditMode" class="value">{{ investAppData.contactPhone }}</span>
            <a-input v-else v-model="investAppEditData.contactPhone" :placeholder="$t('system.parameterConfiguration.inputPlaceholder')" style="width: 200px;" />
          </div>
          <div class="info-item">
            <span class="label">{{ $t('system.parameterConfiguration.whatsappAccount') }}</span>
            <span v-if="!investEditMode" class="value">{{ investAppData.whatsappAccount }}</span>
            <a-input v-else v-model="investAppEditData.whatsappAccount" :placeholder="$t('system.parameterConfiguration.inputPlaceholder')" style="width: 200px;" />
          </div>
          <div class="info-item">
            <span class="label">{{ $t('system.parameterConfiguration.email') }}</span>
            <span v-if="!investEditMode" class="value">{{ investAppData.email }}</span>
            <a-input v-else v-model="investAppEditData.email" :placeholder="$t('system.parameterConfiguration.inputPlaceholder')" style="width: 200px;" />
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import { getList, getaddOrUpdate, getVnAppValueInfo, modifyVnAppValueInfo } from '@/webpublicapi/vietnamBackstage'

export default {
  name: 'ParameterConfiguration',
  data() {
    return {
      loanEditMode: false,
      investEditMode: false,
      investLoading: false,
      loanAppData: {
        contactPhone: '',
        whatsappAccount: '',
        email: '',
      },
      loanAppEditData: {
        contactPhone: '',
        whatsappAccount: '',
        email: '',
      },
      investAppData: {
        contactPhone: '',
        whatsappAccount: '',
        email: '',
      },
      investAppEditData: {
        contactPhone: '',
        whatsappAccount: '',
        email: '',
      },
      investConfigData: null,
    }
  },
  mounted() {
    this.loadLoanConfig()
    this.loadInvestConfig()
  },
  methods: {
    // ========== Loan APP  ==========
    async loadLoanConfig() {
      try {
        const res = await getVnAppValueInfo()
        if (res.data) {
          this.loanAppData = {
            contactPhone: res.data.phone || '',
            whatsappAccount: res.data.whatsapp || '',
            email: res.data.email || '',
          }
        }
      } catch (e) {
        this.$message.error(this.$t('common.requestFailed'))
      }
    },
    handleEdit(type) {
      if (type === 'loan') {
        this.loanEditMode = true
        this.loanAppEditData = { ...this.loanAppData }
      }
    },
    handleLoanCancel() {
      this.loanEditMode = false
      this.loanAppEditData = { ...this.loanAppData }
      this.$message.success(this.$t('system.parameterConfiguration.canceled'))
    },
    async handleLoanSave() {
      if (!this.loanAppEditData.contactPhone && !this.loanAppEditData.whatsappAccount && !this.loanAppEditData.email) {
        this.$message.warning(this.$t('system.parameterConfiguration.fillAtLeastOne'))
        return
      }
      try {
        await modifyVnAppValueInfo({
          phone: this.loanAppEditData.contactPhone,
          whatsapp: this.loanAppEditData.whatsappAccount,
          email: this.loanAppEditData.email,
        })
        this.loanAppData = { ...this.loanAppEditData }
        this.loanEditMode = false
        this.$message.success(this.$t('system.parameterConfiguration.saved'))
      } catch (e) {
        this.$message.error(this.$t('common.requestFailed'))
      }
    },

    // ========== Invest APP  ==========
    async loadInvestConfig() {
      this.investLoading = true
      try {
        const res = await getList()
        if (res.respData && res.respData.length > 0) {
          const data = res.respData[0]
          this.investConfigData = data
          this.investAppData = {
            contactPhone: data.servicePhone || '',
            whatsappAccount: data.zalo || '',
            email: data.serviceEmail || '',
          }
        }
      } catch (e) {
        this.$message.error(this.$t('common.requestFailed'))
      } finally {
        this.investLoading = false
      }
    },
    handleInvestEdit() {
      this.investEditMode = true
      this.investAppEditData = { ...this.investAppData }
    },
    handleInvestCancel() {
      this.investEditMode = false
      this.investAppEditData = { ...this.investAppData }
      this.$message.success(this.$t('system.parameterConfiguration.canceled'))
    },
    async handleInvestSave() {
      try {
        const params = {
          id: this.investConfigData ? this.investConfigData.id : undefined,
          servicePhone: this.investAppEditData.contactPhone,
          serviceEmail: this.investAppEditData.email,
          zalo: this.investAppEditData.whatsappAccount,
        }
        await getaddOrUpdate(params)
        this.investAppData = { ...this.investAppEditData }
        this.investEditMode = false
        this.$message.success(this.$t('system.parameterConfiguration.saved'))
      } catch (e) {
        this.$message.error(this.$t('common.requestFailed'))
      }
    },
  },
}
</script>

<style lang="less" scoped>
.parameter-configuration {
  padding: 20px;

  .page-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
  }

  .app-section {
    background: #f5f5f5;
    border-radius: 4px;
    margin-bottom: 16px;

    .section-header {
      padding: 12px 16px;
      background: #fafafa;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      align-items: center;

      .app-name {
        flex: 1;
        font-weight: 600;
        color: #333;
      }
    }

    .section-content {
      padding: 16px;

      .info-item {
        margin-bottom: 12px;
        font-size: 14px;
        display: flex;
        align-items: center;
        min-height: 32px;

        .label {
          color: #666;
          width: 180px;
          white-space: nowrap;
          flex-shrink: 0;
          text-align: right;
          margin-right: 16px;
        }

        .value {
          color: #333;
          flex: 0 0 auto;
        }
      }
    }
  }
}
</style>
